__turbopack_context__.v({
  "container": "JxRFEa_container",
  "image": "JxRFEa_image",
  "label": "JxRFEa_label",
  "title": "JxRFEa_title",
});
